'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstError = exports.getFormErrors = exports.augmentSubmitActionWithAdditionalData = exports.getFormFieldValue = exports.getFormValues = exports.getFormFieldInitialValue = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = require('redux-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFormFieldInitialValue = exports.getFormFieldInitialValue = function getFormFieldInitialValue(form, field) {
  return function (state) {
    return ((0, _reduxForm.getFormInitialValues)(form)(state) || {})[field];
  };
};

var getFormValues = exports.getFormValues = function getFormValues(form) {
  return function (state) {
    return (0, _reduxForm.getFormValues)(form)(state) || {};
  };
};
var getFormFieldValue = exports.getFormFieldValue = function getFormFieldValue(form, field, defaultValue) {
  return function (state) {
    var value = getFormValues(form)(state)[field];
    return typeof value === 'undefined' ? defaultValue : value;
  };
};

var augmentSubmitActionWithAdditionalData = exports.augmentSubmitActionWithAdditionalData = function augmentSubmitActionWithAdditionalData(action, extraData) {
  return function (data, dispatch) {
    return action((0, _extends3.default)({}, data, extraData), dispatch);
  };
};

var getFormErrors = exports.getFormErrors = function getFormErrors(formName) {
  var getMainError = (0, _reduxForm.getFormError)(formName);
  var getErrors = (0, _reduxForm.getFormSyncErrors)(formName);
  var getMeta = (0, _reduxForm.getFormMeta)(formName);

  return function (state) {
    var formError = getMainError(state);
    var errors = getErrors(state);

    if (!errors && !formError) {
      return;
    }
    if (formError) {
      return formError;
    }

    var meta = getMeta(state) || {};
    var erroredFields = (0, _keys2.default)(errors);
    var touchedErrors = erroredFields.filter(function (field) {
      return meta[field] && meta[field].touched && errors[field];
    }).reduce(function (memo, field) {
      memo[field] = errors[field];
      return memo;
    }, {});

    return touchedErrors;
  };
};

var getFirstError = exports.getFirstError = function getFirstError(formName) {
  var getMainError = (0, _reduxForm.getFormError)(formName);
  var getErrors = (0, _reduxForm.getFormSyncErrors)(formName);
  var getMeta = (0, _reduxForm.getFormMeta)(formName);

  return function (state) {
    var formError = getMainError(state);
    var errors = getErrors(state);

    if (!errors && !formError) {
      return;
    }
    if (formError) {
      return formError;
    }

    var meta = getMeta(state) || {};
    var erroredFields = (0, _keys2.default)(errors);
    return errors[erroredFields.find(function (field) {
      return meta[field] && meta[field].touched;
    })];
  };
};